module.exports = __webpack_public_path__ + "img/winnerIcon.cd9bfbb2.png";